// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ allowedUserTypes }) => {
    const { access_token, userType } = useAuth();

    // 1. Check if authenticated at all
    if (!access_token) {
        return <Navigate to="/Login" replace />;
    }

    // 2. If allowedUserTypes are specified, check user type
    if (allowedUserTypes && allowedUserTypes.length > 0) {
        if (!userType || !allowedUserTypes.includes(userType)) {
            // User is authenticated but doesn't have the correct type
            // Redirect to a 'permission denied' page or their main dashboard
            console.warn(`Access Denied: User type '${userType}' not allowed for this route.`);
            // You can redirect to a specific "access denied" page or their general dashboard
            // For now, let's redirect to a general authenticated home or their detected dashboard
            switch (userType) {
                case 'student':
                case 'accommodation_provider':
                case 'primary_representative':
                case 'secondary_representative':
                case 'bmo_officer':
                case 'funder_primary_representative':
                case 'funder_secondary_representative':
                case 'funder_officer':
                    return <Navigate to="/general-dashboard" replace />;
                case 'back_office':
                    return <Navigate to="/backoffice-dashboard" replace />;
                case 'bmo_user_admin':
                    return <Navigate to="/bmo-user-admin-dashboard" replace />;
                case 'tutoring_agent':
                    return <Navigate to="/tutor-provider-dashboard" replace />;
                case 'tutor':
                    return <Navigate to="/tutor-dashboard" replace />;
                default:
                    // If user type is unknown or not handled, redirect to general login
                    return <Navigate to="/Login" replace />;
            }
        }
    }

    // If authenticated and user type is allowed (or not restricted), render the children
    return <Outlet />;
};

export default PrivateRoute;